import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import Buttons from '../icons/button';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/patched-text.scss';

const propTypes = {
    color: AppPropTypes.color,
    theme: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#FFF',
    theme: null,
    label: null,
    className: null,
};

const PatchedText = ({ color, theme, label, className }) => {
    const BackgroundPatch = Buttons.large;
    const backgroundStyle = theme !== 'dark' ? { color } : { color: '#fff' };
    const textStyle = theme !== 'dark' ? { color: '#fff' } : { color };
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner} style={backgroundStyle}>
                <span className={styles.label} style={textStyle}>
                    {label}
                </span>
                <BackgroundPatch className={styles.background} />
            </div>
        </div>
    );
};

PatchedText.propTypes = propTypes;
PatchedText.defaultProps = defaultProps;

const WithStateContainer = connect(({ site: { color, theme } }) => ({
    color,
    theme,
}))(PatchedText);

export default WithStateContainer;
